import React from "react";
import styles from "./ConversationSeparator.module.css";
import {
    showCopiedSuccessfullyToastNotification
} from "../../../../../../elements/toastNotification/toastNotificationSlice";
import {useAppDispatch} from "../../../../../../../app/hooks";

interface ConversationSeparatorProps {
    conversationId: number
}

export const ConversationSeparator: React.FC<ConversationSeparatorProps> = ({
                                                                                conversationId
                                                                            }) => {

    const dispatch = useAppDispatch()
    const copyConversationId = () => {
        navigator.clipboard.writeText(String(conversationId));
        dispatch(
            showCopiedSuccessfullyToastNotification({fieldName: "Conversation ID"})
        )
    }

    return <div className={styles.wrapper}>
        <div className={styles.line}/>
        <span
            className={styles.conversationId}
            onClick={copyConversationId}
        >
            # {conversationId.toString().slice(-6)}
        </span>
        <div className={styles.line}/>
    </div>
}
